import { AddExerciseToPatientPayload } from '_api/types';
import dayjs from 'dayjs';

const DefaultAddExerciseToPatientSettings: AddExerciseToPatientPayload = {
  contentId: 0,
  regimenType: '',
  reps: 0,
  sets: 0,
  perDay: 1,
  perWeek: 1,
  schedule: ['M'],
  patientId: '',
  instructionList: [],
  description: '',
  defaultTargetSide: 'NA',
  assignedDate: dayjs().format('YYYY-MM-DD'),
};

export default DefaultAddExerciseToPatientSettings;
